import { useContext } from 'react';

import { SPREADSHEET_CONTEXT } from './SpreadsheetContext';
import { SpreadsheetContextQueryVariables, SpreadsheetContext } from '../types';

/**
 * A custom hook that provides access to the spreadsheet context.
 *
 * @template V - The type of the spreadsheet context query variables. Defaults to `SpreadsheetContextQueryVariables`.
 * @returns The spreadsheet context.
 *
 * @throws If the hook is used outside of a `SpreadsheetProvider`.
 */
export function useSpreadsheetContext<
  V extends SpreadsheetContextQueryVariables = SpreadsheetContextQueryVariables,
>(): SpreadsheetContext<V> {
  const context = useContext(SPREADSHEET_CONTEXT);

  if (!context) {
    throw new Error('"useSpreadsheetContext" must be used within a "SpreadsheetProvider"');
  }

  return context as unknown as SpreadsheetContext<V>;
}
